var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3047 24H27.6893",
    stroke: "#219EBC",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3053 21.1657V28.6811C20.3053 33.2498 18.4591 35.0772 13.8437 35.0772H8.30529C3.6899 35.0772 1.84375 33.2498 1.84375 28.6811V21.1657C1.84375 16.597 3.6899 14.7695 8.30529 14.7695H13.8437C18.4591 14.7695 20.3053 16.597 20.3053 21.1657Z",
    stroke: "#219EBC",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1569 21.1657V28.6811C46.1569 33.2498 44.3107 35.0772 39.6953 35.0772H34.1568C29.5415 35.0772 27.6953 33.2498 27.6953 28.6811V21.1657C27.6953 16.597 29.5415 14.7695 34.1568 14.7695H39.6953C44.3107 14.7695 46.1569 16.597 46.1569 21.1657Z",
    stroke: "#219EBC",
    strokeWidth: 2.76923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass2);
export default __webpack_public_path__ + "static/media/glass2.3c3aefdacc8d13becdcf0960bc44aa72.svg";
export { ForwardRef as ReactComponent };